export default __webpack_public_path__ + "static/media/Group 1823.993f81be.png";